'use strict';

var _webmidi = require('webmidi');

var _webmidi2 = _interopRequireDefault(_webmidi);

var _subphatty = require('./subphatty');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var output = void 0;
var channel = 1;

function init() {
  build();
  bind();
  _webmidi2.default.enable(ready);
}
function ready(err) {
  if (err) {
    console.error('webmidi failed to initialize');
    return;
  }
  if (!_webmidi2.default.outputs.length) {
    console.error('no MIDI output found');
  }
  console.log(_webmidi2.default.inputs);
  console.log(_webmidi2.default.outputs);
  output = _webmidi2.default.outputs[0];
}
function build() {
  var section_template = document.querySelector('#section_template').innerHTML;
  var checkbox_template = document.querySelector('#checkbox_template').innerHTML;
  var range_template = document.querySelector('#range_template').innerHTML;
  var enum_template = document.querySelector('#enum_template').innerHTML;
  var params_by_tag = _subphatty.params.reduce(function (a, b, i) {
    var tag = b.tag || b.name.split(' ')[0];
    b.index = i;
    if (a[tag]) {
      a[tag].push(b);
    } else {
      a[tag] = [b];
    }
    return a;
  }, {});
  Object.keys(params_by_tag).map(function (tag) {
    var els = params_by_tag[tag].map(function (param) {
      var t = void 0,
          options = void 0;
      switch (param.type) {
        case 'checkbox':
          t = checkbox_template.replace(/{name}/, param.name).replace(/{param_name}/, param.name.replace(/ /g, '_')).replace(/{index}/, param.index);
          break;
        case 'range':
          t = range_template.replace(/{name}/, param.name).replace(/{param_name}/, param.name.replace(/ /g, '_')).replace(/{index}/, param.index).replace(/{min}/, param.range[0]).replace(/{max}/, param.range[1]).replace(/{value}/, Math.floor((param.range[1] - param.range[0]) / 2));
          break;
        case 'enum':
          options = param.values.map(function (a) {
            return '<option value="' + a[0] + '">' + a[1] + '</option>';
          });
          t = enum_template.replace(/{name}/, param.name).replace(/{param_name}/, param.name.replace(/ /g, '_')).replace(/{index}/, param.index).replace(/{options}/, options).replace(/{value}/, param.values[0][0]);
          break;
        default:
          console.log('unknown type', param);
          t = "";
          break;
      }
      return t;
    }).filter(function (t) {
      return !!t;
    });
    var t = section_template.replace(/{name}/, tag).replace(/{els}/, els.join(''));
    document.querySelector('#params').innerHTML += t;
  });
}
function bind() {
  toArray(document.querySelectorAll('#params input[type=range]')).forEach(function (el) {
    var index = el.dataset.index;
    var param = _subphatty.params[index];
    el.addEventListener('input', function () {
      update_param(param, el.value);
    });
  });
  toArray(document.querySelectorAll('#params input[type=checkbox]')).forEach(function (el) {
    var index = el.dataset.index;
    var param = _subphatty.params[index];
    el.addEventListener('input', function () {
      var isChecked = el.checked;
      var value = isChecked ? param.on : param.off;
      update_param(param, value);
    });
  });
  toArray(document.querySelectorAll('#params select')).forEach(function (el) {
    var index = el.dataset.index;
    var param = _subphatty.params[index];
    el.addEventListener('input', function () {
      update_param(param, el.value);
    });
  });
  document.querySelector('#randomize').addEventListener('click', randomize);
}
function update_param(param, value) {
  if (param.fourteen) {
    var msb = value >> 7;
    var lsb = value & 127;
    output.sendControlChange(param.fourteen[0], msb, channel);
    output.sendControlChange(param.fourteen[1], lsb, channel);
  } else {
    output.sendControlChange(param.cc, value, channel);
  }
}
function randint(n) {
  return Math.floor(Math.random() * n);
}
function randomize() {
  _subphatty.params.forEach(function (param) {
    var value = void 0;
    if (param.randomize === false) return;
    if (param.type === 'range') {
      value = randint(param.range[1]);
      update_param(param, value);
      document.querySelector("input[name=" + param.name.replace(/ /g, '_') + "]").value = value;
    }
  });
}
function toArray(a) {
  return Reflect.apply(Array.prototype.slice, a, []);
}

init();